if($('.type-detail').length){
    
}